import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueAnalytics from 'vue-analytics';

import zhTW from 'vant/lib/locale/lang/zh-TW';
import {
  Button,
  SwipeCell,
  Cell,
  CellGroup,
  Overlay,
  Icon,
  ActionSheet,
  Tabbar,
  TabbarItem,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  Col,
  Row,
  Divider,
  NavBar,
  Popup,
  Area,
  Switch,
  Tag,
  DatetimePicker,
  Form,
  Field,
  Calendar,
  RadioGroup,
  Radio,
  Tab,
  Tabs,
  Picker,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Lazyload,
  Skeleton,
  ImagePreview,
} from 'vant';
const vantList = {
  Button,
  SwipeCell,
  Cell,
  CellGroup,
  Overlay,
  Icon,
  ActionSheet,
  Tabbar,
  TabbarItem,
  Grid,
  GridItem,
  Swipe,
  SwipeItem,
  Col,
  Row,
  Divider,
  NavBar,
  Popup,
  Area,
  Switch,
  Tag,
  DatetimePicker,
  Form,
  Field,
  Calendar,
  RadioGroup,
  Radio,
  Tab,
  Tabs,
  Picker,
  Dialog,
  Checkbox,
  CheckboxGroup,
  Lazyload,
  Skeleton,
  ImagePreview,
};
for (let i in vantList) {
  Vue.use(vantList[i], zhTW);
}

Vue.use(VueAnalytics, {
  id: 'UA-140692233-2',
  router,
  autoTracking: {
    pageviewOnLoad: false,
  },
});

Vue.config.productionTip = false;

Vue.prototype.$liff = window.liff;
Vue.prototype.$platform = window.platform;

if (window.location.href.includes('/?liff')) {
  window.liff.init({ liffId: '1650128613-BGm2goLA' });
} else {
  (function() {
    window.liff
      .init({ liffId: '1650128613-BGm2goLA' })
      .then(() => {
        return store.dispatch('initLiffUserData');
      })
      .then(() => {
        new Vue({
          router,
          store,
          render: (h) => h(App),
        }).$mount('#app');
      })
      .catch((err) => {
        console.log('我是錯誤');
        console.log(err);
        new Vue({
          router,
          store,
          render: (h) => h(App),
        }).$mount('#app');
      });
  })();
}
